import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Link, withRouter } from "react-router-dom"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Collapse,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  UncontrolledAlert
} from "reactstrap"

import classnames from "classnames"
import { format } from "date-fns"
import { useFormik } from "formik"
import { isEmpty } from "lodash"
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import { NumericFormat } from "react-number-format"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import * as Yup from "yup"
import ConfirmModal from "../../../components/Common/ConfirmModal"
import FileUpload from "../Upload/fileUpload"
import ApoliceModal from "./ApoliceModal"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
// Form Mask
import InputMask from "react-input-mask"
import { downloadPDF } from "../../../helpers/pdf_generator"
import { generateInsightReport, downloadPDF as downloadInsightPDF } from "../../../helpers/insight_report_generator"
import { getParceiros, getTemplatesByParceiro } from "../../../helpers/parceiro_helper"

import {
  clearSendLeadResult,
  createApolice as onAddApolice,
  createLead as onCreateLead,
  deleteApolice as onDeleteApolice,
  getProcessoCompleto as onGetProcessoCompleto,
  sendLead as onSendLead,
  updateApolice as onUpdateApolice,
  updateLead as onUpdateLead,
  updateProcesso as onUpdateProcesso,
  updatePublicacao as onUpdatePublicacao
} from "store/actions"

//redux
import { postReletedProcess } from "helpers/blopsleads_helper"
import StatusMap from "helpers/statusMap"
import { useDispatch, useSelector } from "react-redux"

const QualificacaoDetail = props => {
  //meta title
  document.title = "Análise do Processo | Qualificação de Leads"

  const [isSending, setIsSending] = useState(false)


  const [isGarantido, setisGarantido] = useState(false)
  const [isSegurado, setisSegurado] = useState(false)
  const [isLead, setisLead] = useState(null)

  const [fileAnexado, setFileAnexado] = useState(false)
  const [leadEnviado, setLeadEnviado] = useState(null)

  const [modalApolice, setModalApolice] = useState(false)
  const [isEditApolice, setIsEditApolice] = useState(false)
  const [apoliceList, setApoliceList] = useState([])
  const [apolice, setApolice] = useState()
  const [indexApolice, setIndexApolice] = useState(null)
  const [confirmModal, setConfirmModal] = useState(false)
  const [customConfirmModal, setCustomConfirmModal] = useState({
    Evento: "",
    Message: "",
  })
  const [processo, setProcesso] = useState({})
  const [accordion0, setAccordion0] = useState(false)
  const [accordion1, setAccordion1] = useState(false)
  const [accordion2, setAccordion2] = useState(false)
  const [accordion3, setAccordion3] = useState(true)
  const [formValuesChanged, setFormValuesChanged] = useState(false)
  const [loading, setLoading] = useState(true)
  const [confirmSave, setConfirmSave] = useState(false)
  const [isLeadSentSuccessfully, setIsLeadSentSuccessfully] = useState(false)
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false)
  const [parceiros, setParceiros] = useState([])

  const dispatch = useDispatch()

  const { processoFull, resultLead } = useSelector(state => ({
    processoFull: state.Processo.processos,
    resultLead: state.Lead.resultLead,
  }));

  const {
    match: { params },
  } = props

  useEffect(() => {
    getParceiros().then(setParceiros).catch(() => {})
  }, [])

  useEffect(() => {
    if (
      params &&
      params.id &&
      params.id !== "-1" &&
      (processoFull == null || processoFull.id !== params.id)
    ) {
      dispatch(onGetProcessoCompleto(params.id))
    } else {
      setProcesso({})
      // showToast("Código de processo inválido.", "warning");
      // window.location  = "/qualificacao";
    }
  }, [params])

  useEffect(() => {
    if (
      processoFull &&
      (isEmpty(processo) || processoFull.Id !== processo.Id)
    ) {
      setProcesso(processoFull)
      setLoading(false)
      if (processoFull.Apolices) {
        setApoliceList(processoFull.Apolices)
      }
    }
  }, [processoFull])


  useEffect(() => {
    if (!resultLead) return

    const itens = Array.isArray(resultLead) ? resultLead : (resultLead.itens || [])
    if (!Array.isArray(itens) || itens.length === 0) return

    const first = itens[0]

      const isGuid = s =>
        typeof s === "string" &&
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(s)

      const extractFromObj = (o) => {
        if (!o || typeof o !== "object") return null
          const v = o.pkLeadJudicial ?? o.pkLeadsJudicial ?? o.pkLead ?? o.id
          return isGuid(v) ? v : null
        }

      const extractPk = f => {
      const ret = f?.retorno ?? f?.Retorno
          // 1) checa campos diretos do próprio item
          const direct = extractFromObj(f)
          if (direct) return direct

          // 2) retorno como string -> tenta JSON/regex
            if (typeof ret === "string" && ret.trim()) {
            const s = ret.trim()
              try {
                const parsed = JSON.parse(s)
                  if (Array.isArray(parsed) && parsed.length) return extractFromObj(parsed[0])
                  if (parsed && typeof parsed === "object") return extractFromObj(parsed)
                } catch (_) {
                const m = s.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/)
                  if (m) return m[0]
                }
            return null
            }

          // 3) retorno como array/objeto
            if (Array.isArray(ret) && ret.length) return extractFromObj(ret[0])
          if (ret && typeof ret === "object") return extractFromObj(ret)
          return null
    }

    const pk = extractPk(first)
      const ok = first?.ok === true || Boolean(pk)

    if (ok && pk) {
        showToast(`Lead enviado com sucesso! (id: ${pk})`, "success")
        setIsLeadSentSuccessfully(true)

        // marca como Enviado no banco + guarda o PK
          if (processo?.Lead?.Id) {
            const payload = {
                Id: processo.Lead.Id,
                Status: "Enviado",
                DataEnvio: new Date().toISOString(),
                PkLeadJudicial: pk,
              }
            dispatch(onUpdateLead(payload))
            // reflete imediatamente na UI
            setProcesso(prev => ({
                ...prev,
                Lead: { ...(prev.Lead || {}), ...payload }
            }))
          }
    } else {
      const msg  = first?.error || first?.message || "Falha no envio"
      const dest = (resultLead?.destino || "pottencial").toUpperCase()
      showToast(`[${dest}] Lead não enviado: ${msg}`, "warning")
    }

    setIsSending(false)
    dispatch(clearSendLeadResult())
  }, [resultLead, dispatch])



  // Função para atualizar o estado
  const atualizarLead = updatedLead => {
    setProcesso(prevProcesso => ({
      ...prevProcesso,
      Lead: updatedLead,
    }))
  }




  useEffect(() => {
    if (isLeadSentSuccessfully) {
      dispatch(
        onUpdateProcesso({
          Id: processo.Id,
          Monitored: true,
        })
      )

      setProcesso(prevProcesso => ({
        ...prevProcesso,
        Monitored: true,
      }))

      processo.Publicacoes.map(publi => {
        const updatedPublicacao = {
          Id: publi.Id,
          Status: StatusMap.Monitorado.value,
        }
        dispatch(onUpdatePublicacao(updatedPublicacao))
      })
    }
  }, [isLeadSentSuccessfully])

  useEffect(() => {
    if (processo) {
      setisLead(processo.IsLead)
    }
  }, [processo])

  useEffect(() => {
    setIndexApolice(apoliceList.length)
  }, [apoliceList])

  const toggleAccordion0 = () => {
    setAccordion0(!accordion0)
  }

  const toggleAccordion1 = () => {
    setAccordion1(!accordion1)
  }

  const toggleAccordion2 = () => {
    setAccordion2(!accordion2)
  }
  const toggleAccordion3 = () => {
    setAccordion3(!accordion3)
  }

  const toggleApolice = () => {
    if (modalApolice) {
      setModalApolice(false)
    } else {
      if (!isEditApolice) {
        // console.log('TO-DO: RESET FORM APOLICE');
      }
      setModalApolice(true)
    }
  }

  const pendingIds = JSON.parse(localStorage.getItem("pendingIds")) || []
  const getProximo = () => {
    const i = pendingIds.indexOf(processo.Id)
    if (i > -1) {
      const id = pendingIds[(i + 1) % pendingIds.length]
      return id
    } else {
      return -1
    }
  }

  const getAnterior = () => {
    const i = pendingIds.indexOf(processo?.Id || "")
    if (i > 0) {
      const id = pendingIds[(i - 1) % pendingIds.length]
      return id
    } else {
      return -1
    }
  }

  const handleSendLead = () => {
    if (alreadySent) {
        toastr.warning("Este lead já foi enviado.");
        return;
      }
    const destino = validation?.values?.leadDestino || "pottencial"
    const destinoLabelMap = {
      pottencial: "Pottencial",
      daycoval: "Daycoval",
      xp: "XP",
      abc: "ABC",
      galapagos: "Galapagos",
      genial: "Genial",
      safra: "Safra",
      ezze: "Ezze",
      lockton: "Lockton",
      swissre: "Swiss Re",
      aon: "Aon",
      avla: "Avla",
      tokio: "Tokio Marine",
      demais: "Demais",
    }
    const destinoLabel = destinoLabelMap[destino] || "Pottencial"
    setCustomConfirmModal({
      Evento: "EnviarLead",
      Message:
        `Os dados do lead serão enviados para o cliente ${destinoLabel}. Deseja prosseguir?`,
    })
    setConfirmModal(true)
  }

  const handleStopMonitor = () => {
    setCustomConfirmModal({
      Evento: "PararMonitoramento",
      Message: "Você realmente deseja parar o monitoramento?",
    })
    setConfirmModal(true)
  }


  const sendPottencialLead = () => {
    if (processo?.Lead?.Status === "Enviado") {
        toastr.warning("Este lead já foi enviado.");
        return;
      }
    const leadId = processo?.Lead?.Id || ""
    const idOk = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(leadId)
    if (!idOk) { toastr.error("Salve o lead antes de enviar (ID inválido)."); return }

    const { ProcessoRelacionado, ...leadSemProcessoRelacionado } = processo.Lead
    const updatedLead = { ...leadSemProcessoRelacionado, Status: "Completo" }

    if (!!processo && validation.isValid && !isSending) {
      setIsSending(true)
      const result = dispatch(onSendLead({
        ...processo.Lead,
        Destino: validation?.values?.leadDestino || "pottencial",
      }))
      setLeadEnviado({ result })
      dispatch(onUpdateLead(updatedLead))
    }
  }


  const checkProcessStatus = async processoRelacionado => {
    if (!processoRelacionado?.trim()) {
      toastr.error("Por favor, informe ao menos um processo para verificação.")
      return
    }

    const processos = processoRelacionado
      .split(";")
      .map(p => p.trim())
      .filter(p => p)

    try {
      const response = await postReletedProcess(processos)

      if (response.result.length > 0) {
        const processLinks = response.result
          .map(
            p => `
                        <div class="process-link-container" 
                             style="
                                margin: 8px 0;
                                padding: 10px;
                                background: rgba(255, 255, 255, 0.1);
                                border-radius: 4px;
                                transition: background-color 0.2s;
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                gap: 8px;
                             "
                             onclick="window.open('/qualificacao-detail/${p.Id}', '_blank')"
                        >
                            <i class="fas fa-external-link-alt" 
                               style="color: #ffffff; font-size: 14px;"
                            ></i>
                            <span style="
                                color: #ffffff;
                                text-decoration: none;
                                font-weight: 700;
                                flex: 1;
                            ">
                                ${p.NumeroCNJ}
                            </span>
                        </div>
                    `
          )
          .join("")

        const message = `
                <div style="color: #ffffff;">
                    <p style="margin-bottom: 10px;">
                        <i class="fas fa-exclamation-circle"></i>
                        <strong>Atenção!</strong> ${response.result.length} processo(s) já analisado(s):
                    </p>
                    <div style="max-height: 200px; overflow-y: auto;">
                        ${processLinks}
                    </div>
                </div>
            `

        toastr.warning(message, "Processos Analisados", {
          timeOut: 20000,
          extendedTimeOut: 8000,
          allowHtml: true,
          progressBar: true,
          closeButton: true,
          preventDuplicates: true,
          positionClass: "toast-top-right",
          onShown: function () {
            const containers = document.querySelectorAll(
              ".process-link-container"
            )
            containers.forEach(container => {
              container.addEventListener("mouseenter", function () {
                this.style.backgroundColor = "rgba(255, 255, 255, 0.2)"
              })
              container.addEventListener("mouseleave", function () {
                this.style.backgroundColor = "rgba(255, 255, 255, 0.1)"
              })
            })
          },
        })
      } else {
        toastr.success(
          "Ainda não houve análise para nenhum dos processos informados.",
          "Status dos Processos",
          {
            timeOut: 5000,
            progressBar: true,
          }
        )
      }
    } catch (error) {
      console.error("Erro ao buscar status dos processos:", error)
      toastr.error(
        "Não foi possível verificar o status dos processos. Tente novamente.",
        "Erro",
        { timeOut: 5000, progressBar: true }
      )
    }
  }

  const cancelMonitor = () => {
    dispatch(
      onUpdateProcesso({
        Id: processo.Id,
        Monitored: false,
        IsLead: false,
        MotivoNotLead: "Outros",
      })
    )

    setProcesso(prevProcesso => ({
      ...prevProcesso,
      Monitored: false,
      IsLead: false,
      MotivoNotLead: "Outros",
    }))

    validation.setValues({
      processoIsLead: false,
    })

    processo.Publicacoes.map(publi => {
      const updatedPublicacao = {
        Id: publi.Id,
        // LeadAnalisado: new Date().toISOString().slice(0, 19).replace('T', ' '),
        Status: StatusMap.NaoMonitorado.value,
      }
      dispatch(onUpdatePublicacao(updatedPublicacao))
    })
  }

  const handleConfirmModal = () => {
    if (customConfirmModal.Evento === "EnviarLead") {
      sendPottencialLead()
    }
    if (customConfirmModal.Evento === "PararMonitoramento") {
      cancelMonitor()
    }
    if (customConfirmModal.Evento === "ExcluirApolice") {
      deleteApolice()
    }
    setConfirmModal(false)
  }

  const deleteApolice = () => {
    dispatch(onDeleteApolice(apolice))

    const updatedList = apoliceList.filter(item => item.Id !== apolice.Id)
    setApoliceList(updatedList)

    try {
      dispatch(onDeleteApolice(apolice))
      showToast("Apólice deletada com sucesso!", "success")
    } catch (error) {
      setApoliceList(apoliceList)
      showToast("Erro ao deletar a apólice.", "error")
    }
  }

  function showToast(message, toastType, title) {
    toastr.options = {
      positionClass: "toast-top-center",
    }

    //Toaster Types
    if (toastType === "info") toastr.info(message, title)
    else if (toastType === "warning") toastr.warning(message, title)
    else if (toastType === "error") toastr.error(message, title)
    else toastr.success(message, title)
  }

  function addNewApolice(newApolice) {
    const newList = apoliceList.concat(newApolice)

    if (newApolice.Id.length == 36) {
      dispatch(onUpdateApolice(newApolice))
    } else {
      dispatch(onAddApolice(newApolice))
    }

    setApoliceList(newList)
  }

  // Função para gerar documentos em PDF
  const handleGenerateDocuments = async (e) => {
    e.preventDefault()
    
    // Evitar múltiplos cliques enquanto está gerando
    if (isGeneratingPDF) return
    
    try {
      setIsGeneratingPDF(true)
      showToast("Gerando documento PDF (isso pode levar alguns segundos)...", "info")
      
      const parceiroId = validation?.values?.leadParceiroId
      let pdfBlob

      if (parceiroId) {
        const templates = await getTemplatesByParceiro(parceiroId)
        const template = templates.find(t => t.Ativo) || templates[0] || {}
        pdfBlob = await generateInsightReport(processo, template)
      } else {
        pdfBlob = await generateInsightReport(processo, {})
      }
      
      const filename = `Processo_${processo.NumeroCNJ || 'documento'}.pdf`
      downloadPDF(pdfBlob, filename)
      
      showToast("Documento PDF gerado com sucesso!", "success")
    } catch (error) {
      console.error("Erro ao gerar PDF:", error)
      showToast("Erro ao gerar o documento PDF.", "error")
    } finally {
      setIsGeneratingPDF(false)
    }
  }

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      processoId: (processo && processo.Id) || "",
      processoNumeroCNJ: (processo && processo.NumeroCNJ) || "",
      processoObservacao: (processo && processo.Observacao) || "",
      processoIsLead: Boolean(processo && processo.IsLead),
      processoMotivoNotLead: (processo && processo.MotivoNotLead) || "",
      processoGarantia: (processo && processo.Garantia) || "",
      processoMonitorado: processo?.Monitored || "",
      //dados entidade lead
      leadId: (processo && processo.Lead && processo.Lead.Id) || "",
      leadReuRazaoSocial:
        (processo && processo.Lead && processo.Lead.ReuRazaoSocial) || "",
      leadReuCNPJ: (processo && processo.Lead && processo.Lead.ReuCNPJ) || "",
      leadReuEndereco:
        (processo && processo.Lead && processo.Lead.ReuEndereco) || "",
      leadReuCEP: (processo && processo.Lead && processo.Lead.ReuCEP) || "",
      leadReuCidade:
        (processo && processo.Lead && processo.Lead.ReuCidade) || "",
      leadReuUF: (processo && processo.Lead && processo.Lead.ReuUF) || "",
      leadReclamante:
        (processo && processo.Lead && processo.Lead.Reclamante) || "",
      leadTribunal: (processo && processo.Lead && processo.Lead.Tribunal) || "",
      leadVara: (processo && processo.Lead && processo.Lead.Vara) || "",
      leadDataAjuizamento: (() => {
        const m = moment(processo?.Lead?.DataAjuizamento, "YYYY-MM-DD")
        return m.isValid() ? m.format("DD/MM/YYYY") : ""
      })(),
      leadValorCausa:
        (processo && processo.Lead && processo.Lead.ValorCausa) || "",
      leadEsfera: (processo && processo.Lead && processo.Lead.Esfera) || "",
      leadObjetoSegurado:
        (processo && processo.Lead && processo.Lead.ObjetoSegurado) || "",
      leadTipoLead: (processo && processo.Lead && processo.Lead.TipoLead) || "",
      leadSituacaoLead:
        (processo && processo.Lead && processo.Lead.SituacaoLead) || "",
      // destino do lead
      leadDestino:
        (processo && processo.Lead && processo.Lead.Destino) || "",
      leadParceiroId:
        (processo && processo.Lead && processo.Lead.ParceiroId) || "",
      leadProcessoRelacionado:
        (processo && processo.Lead && processo.Lead.ProcessoRelacionado) || "",
      leadStatus:
        (processo && processo.Lead && processo.Lead.Status) || "Não é Lead",
    },
    validationSchema: Yup.object({
      processoIsLead: Yup.string()
        .nullable()
        .required("Por favor informe se é um Lead"),
      processoMotivoNotLead: Yup.string().when("processoIsLead", {
        is: "false",
        then: Yup.string().required("Por favor informe motivo de não ser Lead"),
      }),
      processoGarantia: Yup.string().when("processoMotivoNotLead", {
        is: "Garantido",
        then: Yup.string().required("Por favor informe o tipo de Garantia"),
      }),
      //dados do lead
      leadReuRazaoSocial: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe a Razão Social"),
      }),
      leadReuCNPJ: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe o CNPJ"),
      }),
      leadReclamante: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe a Parte Contrária"),
      }),
      leadTribunal: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe o Tribunal"),
      }),
      leadVara: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe a Vara"),
      }),
      leadDataAjuizamento: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe a Data de Ajuizamento"),
      }),
      leadValorCausa: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe o Valor da Causa"),
      }),
      leadEsfera: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe a Esfera do processo"),
      }),
      leadObjetoSegurado: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe o Objeto Segurado"),
      }),
      leadTipoLead: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe o Tipo de Lead"),
      }),
      leadSituacaoLead: Yup.string().when("processoIsLead", {
        is: "true",
        then: Yup.string().required("Por favor informe a Situação do Lead"),
      }),
    }),
    onSubmit: values => {
      // update Processo
      const updatedProcesso = {
        Id: values.processoId,
        IsLead: values.processoIsLead,
        Observacao: values.processoObservacao,
        MotivoNotLead: values.processoMotivoNotLead,
        Garantia: values.processoGarantia,
        Monitored: values.processoMonitorado,
      }
      // call
      dispatch(onUpdateProcesso(updatedProcesso))

      setProcesso(prevProcesso => ({
        ...prevProcesso,
        IsLead: values.processoIsLead,
        Observacao: values.processoObservacao,
        MotivoNotLead: values.processoMotivoNotLead,
        Garantia: values.processoGarantia,
        Monitored: values.processoMonitorado,
      }))

      // update Publicações
      processo.Publicacoes.map(publi => {
        const updatedPublicacao = {
          Id: publi.Id,
          LeadAnalisado: new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " "),
          Status: validation.isValid
            ? StatusMap.Concluido.value
            : StatusMap.Incompleto.value,
        }
        dispatch(onUpdatePublicacao(updatedPublicacao))
      })

      const updatedLead = {
        Id: values.leadId,
        Id_Processo: values.processoId,
        ReuRazaoSocial: values.leadReuRazaoSocial,
        ReuCNPJ: values.leadReuCNPJ,
        ReuEndereco: values.leadReuEndereco,
        ReuCEP: values.leadReuCEP,
        ReuCidade: values.leadReuCidade,
        ReuUF: values.leadReuUF,
        Reclamante: values.leadReclamante,
        Tribunal: values.leadTribunal,
        Vara: values.leadVara,
        DataAjuizamento: (() => {
          const m = moment(values.leadDataAjuizamento, "DD/MM/YYYY")
          return m.isValid() ? m.format("YYYY-MM-DD HH:mm:ss") : null
        })(),
        ValorCausa:
          (isNaN(values.leadValorCausa)
            ? values.leadValorCausa
                .replace("R$", "")
                .replaceAll(".", "")
                .replace(",", ".")
            : values.leadValorCausa) || null,
        Esfera: values.leadEsfera,
        ObjetoSegurado: values.leadObjetoSegurado,
        TipoLead: values.leadTipoLead,
        SituacaoLead: values.leadSituacaoLead,
        Destino: values.leadDestino,
        ParceiroId: values.leadParceiroId || null,
        ProcessoRelacionado: values.leadProcessoRelacionado,
        // DataEnvio: new Date().toISOString().slice(0, 19).replace('T', ' '),
        AutosAnexado: fileAnexado,
        Status:
          values.processoIsLead == false && confirmModal
            ? "Não é Lead"
            : "Pendente de Envio",
      }

      //console.log("UPLEAD", updatedLead)

      // add or update Lead se for lead
      if (processo.Lead == null) {
        dispatch(onCreateLead(updatedLead))
        //atualizarLead: () => dispatch(onAddLead(updatedLead))
        atualizarLead(updatedLead)
      } else {
        dispatch(onUpdateLead(updatedLead))
        //atualizarLead: () => dispatch(onAddLead(updatedLead))
        atualizarLead(updatedLead)
      }

      //setTimeout(() => {  dispatch(onGetProcessoCompleto(processo.Id)); }, 2000);
      //window.location.reload(false);

      // handleProximo();
      //window.location = "/qualificacao";
      // console.log('MOSTRA_VALUES', initialValues)

      // showToast('Registro salvo!');

      setConfirmSave(true)
    },
  })

  const searchCNPJ = async cnpj => {
    try {
      const response = await fetch(
        `https://brasilapi.com.br/api/cnpj/v1/${cnpj}`
      )
      const data = await response.json()
      if (data && !data.message) {
        validation.setValues({
          ...validation.values,
          leadReuRazaoSocial: data.razao_social,
          leadReuEndereco: data.logradouro + ", Nº" + data.numero,
          leadReuCidade: data.municipio,
          leadReuUF: data.uf,
          leadReuCEP: data.cep,
        })
      } else {
        showToast(data.message, "warning")
      }
    } catch (error) {
      showToast("Erro ao buscar CNPJ.", "error")
    }
  }

  useEffect(() => {
    if (validation.values.leadReuCNPJ) {
      const cnpj = validation.values.leadReuCNPJ.replace(/\D/g, "")
      if (cnpj.length === 14) {
        searchCNPJ(cnpj)
      }
    }
  }, [validation.values.leadReuCNPJ])

  const handleInputChange = e => {
    validation.handleChange(e)
    setFormValuesChanged(true)
  }

  const handleToggleLead = isLeadValue => {
    const currentValues = validation.values

    validation.setValues({
      ...currentValues,
      processoIsLead: isLeadValue,
    })

    setisLead(isLeadValue)

    if (isLeadValue) {
      setProcesso(prevProcesso => ({
        ...prevProcesso,
        IsLead: isLeadValue,
        MotivoNotLead: "",
      }))
    }

    setFormValuesChanged(true)
  }

  const handleSaveButtonClick = e => {
    e.preventDefault()

    if (!validation.isValid) {
      showToast("Preencha todos os campos obrigatórios!", "error")
    } else {
      showToast("Lead salvo com sucesso!")
    }

    validation.handleSubmit()
    setFormValuesChanged(false)
  }

  // console.log("PROCESS", processo);

  // console.log("LEADSSSSSS", resultLead)

  // console.log("ISLEAD?", isLead)
  // console.log("LEAD", processo);

  const leadResponse = response => {
    atualizarLead(response, "facebook")
  }

  useEffect(() => {
    if (validation.values.processoIsLead != null) {
      setisLead(validation.values.processoIsLead)
    }
  }, [validation.values.processoIsLead])

  const columnsApolices = [
    {
      dataField: "Id",
      text: "Id",
      hidden: true,
    },
    {
      dataField: "Tipo",
      text: "Tipo",
    },
    {
      dataField: "ProcessoContrato",
      text: "Processo",
    },
    {
      dataField: "Seguradora",
      text: "Seguradora",
    },
    {
      dataField: "Corretora",
      text: "Corretora",
    },
    {
      dataField: "ImportanciaSegurada",
      text: "Importância Segurada",
    },
    {
      dataField: "Premio",
      text: "Prêmio",
    },
    {
      dataField: "Endosso",
      text: "Endosso",
    },
    {
      dataField: "Taxa",
      text: "Taxa",
    },
    {
      dataField: "InicioVigencia",
      text: "Início da Vigência",
    },
    {
      dataField: "FimVigencia",
      text: "Fim da Vigência",
    },
    {
      dataField: "actions",
      text: "Ações",
      formatter: (cellContent, row) => (
        <button
          className="btn btn-danger"
          onClick={() => handleDeleteApolice(row)}
        >
          Excluir
        </button>
      ),
    },
  ]

  const handleDeleteApolice = apolice => {
    setCustomConfirmModal({
      Evento: "ExcluirApolice",
      Message: "Você realmente deseja excluir esta apólice?",
    })
    setApolice(apolice)
    setConfirmModal(true)
  }

  // const hasValidLeadId = !!(processo?.Lead?.Id && processo.Lead.Id.length === 36)
  const hasValidLeadId = !!(processo?.Lead?.Id && processo.Lead.Id.length === 36)
  const alreadySent    = processo?.Lead?.Status === "Enviado"


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Qualificação" breadcrumbItem="Análise" />
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
              className="page-content"
            >
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                }}
              >
                Loading...
              </Spinner>
            </div>
          ) : (
            <Form
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      {/* *************************************************** */}
                      <div className="qualificacao-title">
                        <div className="float-end font-size-16">
                          {processo.Monitored ? (
                            <Link
                              to="#!"
                              onClick={() => handleStopMonitor()}
                              className={`btn btn-primary me-2`}
                            >
                              Parar Monitoramento
                            </Link>
                          ) : (
                            (() => {
                              const canSend = isLead === true && confirmSave && hasValidLeadId && !isSending && !alreadySent
                              return (
                                <Link
                                  to="#!"
                                  onClick={e => {
                                    if (!canSend) { e.preventDefault(); return }
                                    handleSendLead()
                                  }}
                                  className={`btn btn-primary me-2 ${canSend ? "" : "disabled"}`}
                                  aria-disabled={!canSend}
                                  tabIndex={canSend ? 0 : -1}
                                >
                                  {isSending ? "Enviando..." : "Enviar"}
                                </Link>
                              )
                            })()
                          )}
                          <Button
                            type="button"
                            onClick={handleGenerateDocuments}
                            className="btn btn-info cursor-pointer save-processo me-2"
                            disabled={isGeneratingPDF}
                          >
                            {isGeneratingPDF ? (
                              <>
                                <Spinner size="sm" className="me-2" />
                                Gerando PDF...
                              </>
                            ) : (
                              'Gerar Documentos'
                            )}
                          </Button>
                          <Button
                            type="submit"
                            onClick={handleSaveButtonClick}
                            className="btn btn-success save-processo me-2"
                            disabled={!formValuesChanged}
                          >
                            Salvar
                          </Button>
                          <Link
                            className={`btn btn-info me-2`}
                            to="#"
                            onClick={() => {
                              window.open(
                                "/linha-do-tempo/" + processo.NumeroCNJ,
                                "_blank"
                              )
                            }}
                          >
                            Linha do Tempo
                          </Link>

                          <Link
                            className="btn btn-outline-primary"
                            to={"/qualificacao-detail/" + getAnterior()}
                          >
                            <i className="fas fa-arrow-left" /> Anterior
                          </Link>
                          <Link
                            className="btn btn-outline-primary"
                            to={"/qualificacao-detail/" + getProximo()}
                          >
                            Próximo <i className="fas fa-arrow-right" />
                          </Link>
                        </div>
                        <div className="mb-4">
                          <h4>Processo # {processo.NumeroCNJ}</h4>
                        </div>
                      </div>
                      <hr />
                      <Row className="ms-2">
                        <Col lg={5}>
                          <div className="mb-3">
                            <label>Todas as Tags</label>
                            <div className="font-size-14">
                              {processo.Publicacoes.map(publi => [
                                publi.Tags.map(tag => [
                                  <Badge
                                    key={tag.Id}
                                    color={tag.Estilo}
                                    className="me-1"
                                  >
                                    {tag.Titulo}
                                  </Badge>,
                                ]),
                              ])}
                            </div>
                          </div>
                        </Col>
                        <Col lg={7}>
                          <Row>
                            <Col lg={4}>
                              <div className="mb-3">
                                <label>É um Lead</label>
                                <Row>
                                  <div className="btn-group mt-3" role="group">
                                    <button
                                      type="button"
                                      className={`btn ${
                                        isLead
                                          ? "btn-primary"
                                          : "btn-outline-primary"
                                      }`}
                                      onClick={() => handleToggleLead(true)}
                                    >
                                      <i className="fas fa-check label-icon"></i>{" "}
                                      Sim
                                    </button>
                                    <button
                                      type="button"
                                      className={`btn ${
                                        !isLead
                                          ? "btn-danger"
                                          : "btn-outline-danger"
                                      }`}
                                      onClick={() => handleToggleLead(false)}
                                    >
                                      <i className="fas fa-times label-icon"></i>{" "}
                                      Não
                                    </button>
                                  </div>

                                  {validation.touched.processoIsLead &&
                                  validation.errors.processoIsLead ? (
                                    <div style={{ color: "red" }}>
                                      {validation.errors.processoIsLead}
                                    </div>
                                  ) : null}
                                </Row>
                              </div>
                            </Col>
                            <Col lg={7}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  Observações
                                </Label>
                                <Input
                                  name="processoObservacao"
                                  type="textarea"
                                  rows="3"
                                  placeholder="Digite detalhes complementares"
                                  onChange={handleInputChange}
                                  value={
                                    validation.values.processoObservacao || ""
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="ms-2">
                        <Col lg={5}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Processos Relacionados
                            </Label>
                            <Input
                              name="leadProcessoRelacionado"
                              type="text"
                              placeholder="Digite o código CNJ dos processos (separados por ;) "
                              onChange={handleInputChange}
                              onBlur={e => checkProcessStatus(e.target.value)}
                              value={
                                validation.values.leadProcessoRelacionado || ""
                              }
                            />
                            {/* <div>Picked: {validation.values.leadProcessoRelacionado}</div>                                                                                                                      
                                <Editable
                                    name="leadProcessoRelacionado"
                                    value={validation.values.leadProcessoRelacionado || ''}                                                
                                    onSubmit={(value) => validation.setFieldValue('leadProcessoRelacionado', value)}
                                    alwaysEditing={false}
                                    disabled={false}
                                    editText="editar"
                                    id={null}
                                    isValueClickable={false}
                                    mode="inline"
                                    placement="top"
                                    showText
                                    type="textfield"
                                    renderConfirmElement={confirmElement}
                                    renderCancelElement={cancelElement}
                                /> */}
                          </div>
                        </Col>
                        <Col lg={7}>
                          {/* NÃO É LEAD: */}
                          {/* <Collapse isOpen={isLead == 'false'} className="accordion-item-collapse"> */}
                          <Collapse
                            isOpen={true}
                            className="accordion-item-collapse"
                          >
                            <Row>
                              <Col lg={4}>
                                <div className="mb-3">
                                  <Label className="form-label">Motivo</Label>
                                  <Input
                                    name="processoMotivoNotLead"
                                    type="select"
                                    onChange={handleInputChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                      validation.touched
                                        .processoMotivoNotLead &&
                                      validation.errors.processoMotivoNotLead
                                        ? true
                                        : false
                                    }
                                    value={
                                      validation.values.processoMotivoNotLead ||
                                      ""
                                    }
                                  >
                                    <option value="">Selecionar...</option>
                                    <option>CDA Cancelada</option>
                                    <option>
                                      Dívida Paga / Parcelamento da Dívida
                                    </option>
                                    <option>Embargos à execução</option>
                                    <option>
                                      Empresa em Recuperação Judicial
                                    </option>
                                    <option>Garantido</option>
                                    <option>Lead abaixo do range</option>
                                    <option>PF</option>
                                    <option>Possui Tutela/Cautelar</option>
                                    <option>
                                      Processo Extinto / Arquivado
                                    </option>
                                    <option>Vencimento futuro</option>
                                    <option>Outros</option>
                                  </Input>
                                  {validation.touched.processoMotivoNotLead &&
                                  validation.errors.processoMotivoNotLead ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.processoMotivoNotLead}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="mb-3">
                                  <Label className="form-label">Destino</Label>
                                  <Input
                                    name="leadParceiroId"
                                    type="select"
                                    onBlur={validation.handleBlur}
                                    value={validation.values.leadParceiroId || ""}
                                    onChange={e => {
                                      const p = parceiros.find(p => String(p.Id) === e.target.value)
                                      validation.setFieldValue("leadParceiroId", e.target.value)
                                      validation.setFieldValue("leadDestino", p ? p.Nome : "")
                                    }}
                                  >
                                    <option value="">Selecionar</option>
                                    {parceiros.filter(p => p.Tipo === "seguradora").length > 0 && (
                                      <optgroup label="Seguradoras">
                                        {parceiros.filter(p => p.Tipo === "seguradora").map(p => (
                                          <option key={p.Id} value={p.Id}>{p.Nome}</option>
                                        ))}
                                      </optgroup>
                                    )}
                                    {parceiros.filter(p => p.Tipo === "corretora").length > 0 && (
                                      <optgroup label="Corretoras">
                                        {parceiros.filter(p => p.Tipo === "corretora").map(p => (
                                          <option key={p.Id} value={p.Id}>{p.Nome}</option>
                                        ))}
                                      </optgroup>
                                    )}
                                  </Input>
                                </div>
                              </Col>
                              <Col lg={4}>
                                {/* <div className="mb-3" style={{display: isGarantido ? 'block' : 'none' }}> */}
                                <div className="mb-3">
                                  <Label className="form-label">
                                    Qual Garantia?
                                  </Label>
                                  <Input
                                    name="processoGarantia"
                                    type="select"
                                    onChange={handleInputChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                      validation.touched.processoGarantia &&
                                      validation.errors.processoGarantia
                                        ? true
                                        : false
                                    }
                                    value={
                                      validation.values.processoGarantia || ""
                                    }
                                  >
                                    <option value="">Selecionar...</option>
                                    <option>Depósito</option>
                                    <option>Seguro</option>
                                    <option>Fiança</option>
                                    <option>Imóvel</option>
                                    <option>Outros Bens</option>
                                  </Input>
                                  {validation.touched.processoGarantia &&
                                  validation.errors.processoGarantia ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.processoGarantia}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </Row>
                          </Collapse>
                        </Col>
                      </Row>
                      <Row>
                        <div
                          className="accordion accordion-flush"
                          id="accordionFlushExample"
                        >
                          <div className="">
                            <h4
                              className="accordion-header"
                              id="headingFlushOne"
                            >
                              <button
                                className={classnames(
                                  "accordion-button",
                                  "fw-medium",
                                  { collapsed: !accordion3 }
                                )}
                                type="button"
                                onClick={toggleAccordion0}
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  backgroundColor: "#EEF1FD",
                                  border: "1px solid white",
                                }}
                              >
                                DOCUMENTOS
                              </button>
                            </h4>
                            <Collapse
                              isOpen={accordion0}
                              className="accordion-collapse"
                            >
                              <div className="accordion-body">
                                <Row>
                                  <Col lg={5}>
                                    {/* É UM LEAD: */}
                                    {/* <Collapse isOpen={isLead == 'true'} className="accordion-item-collapse"> */}
                                    <Collapse
                                      isOpen={true}
                                      className="accordion-item-collapse"
                                    >
                                      <Row>
                                        <Label className="form-label">
                                          Anexar Autos
                                        </Label>
                                        <FileUpload
                                          processo={processo.NumeroCNJ}
                                          anexado={setFileAnexado}
                                          container="autos"
                                        />
                                      </Row>
                                    </Collapse>
                                  </Col>
                                </Row>
                              </div>
                            </Collapse>
                          </div>
                          <div className="">
                            {/* <Collapse isOpen={isSegurado}> */}
                            <Collapse isOpen={true}>
                              <h4
                                className="accordion-header"
                                id="headingFlushOne"
                              >
                                <button
                                  className={classnames(
                                    "accordion-button",
                                    "fw-medium",
                                    { collapsed: !accordion3 }
                                  )}
                                  type="button"
                                  onClick={toggleAccordion3}
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    backgroundColor: "#EEF1FD",
                                    border: "1px solid white",
                                  }}
                                >
                                  DADOS DA APÓLICE
                                </button>
                              </h4>

                              <Collapse
                                isOpen={accordion3}
                                className="accordion-collapse"
                              >
                                <div className="accordion-body">
                                  <Row>
                                    <Col lg={12}>
                                      <Link
                                        to="#!"
                                        onClick={() => toggleApolice()}
                                        className="btn btn-primary"
                                      >
                                        Nova Apólice
                                      </Link>
                                      {apoliceList.length > 0 ? (
                                        <div>
                                          <div className="table-responsive mt-1">
                                            <BootstrapTable
                                              keyField="Id"
                                              data={apoliceList}
                                              columns={columnsApolices}
                                              //cellEdit={cellEditFactory({ mode: "click" })}
                                              bordered={false}
                                              delete
                                            />
                                          </div>
                                          {/* <Link
                                            to="#!"
                                            onClick={() => setApoliceList([])}
                                            className="btn btn-danger disabled"
                                          >
                                            Excluir Apólices
                                          </Link> */}
                                        </div>
                                      ) : (
                                        <div className="d-flex mt-3">
                                          <UncontrolledAlert
                                            color="warning"
                                            className="alert-dismissible fade show"
                                            role="alert"
                                          >
                                            <i className="mdi mdi-alert-outline me-2"></i>
                                            Nenhuma apólice foi inserida. Clique
                                            no botão acima para adicionar.
                                          </UncontrolledAlert>
                                        </div>
                                      )}
                                    </Col>
                                  </Row>
                                </div>
                              </Collapse>
                            </Collapse>
                          </div>
                          <div className="">
                            <h4
                              className="accordion-header"
                              id="headingFlushOne"
                            >
                              <button
                                className={classnames(
                                  "accordion-button",
                                  "fw-medium",
                                  { collapsed: !accordion1 }
                                )}
                                type="button"
                                onClick={toggleAccordion1}
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  backgroundColor: "#EEF1FD",
                                  border: "1px solid white",
                                }}
                              >
                                DADOS DA EMPRESA
                              </button>
                            </h4>
                            <Collapse
                              isOpen={accordion1}
                              className="accordion-item-collapse"
                            >
                              <div className="accordion-body">
                                <Row>
                                  <Col lg={4}>
                                    <div className="mb-3">
                                      <Label className="form-label">CNPJ</Label>
                                      <InputMask
                                        mask="99.999.999/9999-99"
                                        name="leadReuCNPJ"
                                        className="form-control input-color"
                                        placeholder="CNPJ da empresa"
                                        type="text"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadReuCNPJ || ""
                                        }
                                        invalid={
                                          validation.touched.leadReuCNPJ &&
                                          validation.errors.leadReuCNPJ
                                            ? true
                                            : false
                                        }
                                      />
                                      {validation.touched.leadReuCNPJ &&
                                      validation.errors.leadReuCNPJ ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadReuCNPJ}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col lg={8}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Razão Social
                                      </Label>
                                      <Input
                                        name="leadReuRazaoSocial"
                                        placeholder="Nome da empresa réu"
                                        type="text"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values
                                            .leadReuRazaoSocial || ""
                                        }
                                        invalid={
                                          validation.touched
                                            .leadReuRazaoSocial &&
                                          validation.errors.leadReuRazaoSocial
                                            ? true
                                            : false
                                        }
                                      />
                                      {validation.touched.leadReuRazaoSocial &&
                                      validation.errors.leadReuRazaoSocial ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadReuRazaoSocial}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={6}>
                                    <Label className="form-label">
                                      Endereço
                                    </Label>
                                    <Input
                                      name="leadReuEndereco"
                                      placeholder="Endereço da empresa"
                                      type="text"
                                      validate={{
                                        required: { value: true },
                                      }}
                                      onChange={handleInputChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.leadReuEndereco || ""
                                      }
                                      // invalid={
                                      //     isLead && validation.touched.leadReuEndereco && validation.errors.leadReuEndereco ? true : false
                                      // }
                                    />
                                    {validation.touched.leadReuEndereco &&
                                    validation.errors.leadReuEndereco ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.leadReuEndereco}
                                      </FormFeedback>
                                    ) : null}
                                  </Col>
                                  <Col lg={2}>
                                    <Label className="form-label">CEP</Label>
                                    <InputMask
                                      mask="99.999-999"
                                      className="form-control input-color"
                                      name="leadReuCEP"
                                      placeholder="CEP da empresa"
                                      type="text"
                                      validate={{
                                        required: { value: true },
                                      }}
                                      onChange={handleInputChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.leadReuCEP || ""}
                                      // invalid={
                                      //     isLead && validation.touched.leadReuCEP && validation.errors.leadReuCEP ? true : false
                                      // }
                                    />
                                    {validation.touched.leadReuCEP &&
                                    validation.errors.leadReuCEP ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.leadReuCEP}
                                      </FormFeedback>
                                    ) : null}
                                  </Col>
                                  <Col lg={3}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Cidade
                                      </Label>
                                      <Input
                                        name="leadReuCidade"
                                        placeholder="Cidade da empresa"
                                        type="text"
                                        validate={{
                                          required: { value: true },
                                        }}
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadReuCidade || ""
                                        }
                                        // invalid={
                                        //     isLead && validation.touched.leadReuCidade && validation.errors.leadReuCidade ? true : false
                                        // }
                                      />
                                      {validation.touched.leadReuCidade &&
                                      validation.errors.leadReuCidade ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadReuCidade}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col lg={1}>
                                    <div className="mb-3">
                                      <Label className="form-label">UF</Label>
                                      <Input
                                        name="leadReuUF"
                                        type="select"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadReuUF || ""
                                        }
                                        // invalid={validation.touched.leadReuUF && validation.errors.leadReuUF ? true : false}
                                      >
                                        <option value="">Selecionar...</option>
                                        <option>AC</option>
                                        <option>AL</option>
                                        <option>AM</option>
                                        <option>AP</option>
                                        <option>BA</option>
                                        <option>CE</option>
                                        <option>DF</option>
                                        <option>ES</option>
                                        <option>GO</option>
                                        <option>MA</option>
                                        <option>MG</option>
                                        <option>MS</option>
                                        <option>MT</option>
                                        <option>PA</option>
                                        <option>PB</option>
                                        <option>PE</option>
                                        <option>PI</option>
                                        <option>PR</option>
                                        <option>RJ</option>
                                        <option>RN</option>
                                        <option>RO</option>
                                        <option>RR</option>
                                        <option>RS</option>
                                        <option>SC</option>
                                        <option>SE</option>
                                        <option>SP</option>
                                        <option>TO</option>
                                      </Input>
                                      {validation.touched.leadReuUF &&
                                      validation.errors.leadReuUF ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadReuUF}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Collapse>
                          </div>
                          <div className="">
                            <h4
                              className="accordion-header"
                              id="headingFlushOne"
                            >
                              <button
                                className={classnames(
                                  "accordion-button",
                                  "fw-medium",
                                  { collapsed: !accordion2 }
                                )}
                                type="button"
                                onClick={toggleAccordion2}
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  backgroundColor: "#EEF1FD",
                                  border: "1px solid white",
                                }}
                              >
                                DADOS DO LEAD
                              </button>
                            </h4>
                            <Collapse
                              isOpen={accordion2}
                              className="accordion-collapse"
                            >
                              <div className="accordion-body">
                                <Row>
                                  <Col lg={4}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Reclamante
                                      </Label>
                                      <Input
                                        name="leadReclamante"
                                        placeholder="Nome da parte contrária"
                                        type="text"
                                        validate={{
                                          required: { value: true },
                                        }}
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadReclamante || ""
                                        }
                                        invalid={
                                          validation.touched.leadReclamante &&
                                          validation.errors.leadReclamante
                                            ? true
                                            : false
                                        }
                                      />
                                      {validation.touched.leadReclamante &&
                                      validation.errors.leadReclamante ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadReclamante}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col lg={4}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Tribunal
                                      </Label>
                                      <Input
                                        name="leadTribunal"
                                        type="select"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadTribunal || ""
                                        }
                                        invalid={
                                          validation.touched.leadTribunal &&
                                          validation.errors.leadTribunal
                                            ? true
                                            : false
                                        }
                                      >
                                        <option value="">Selecionar...</option>
                                        <option>
                                          Tribunal de Justiça do Acre (TJAC)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Alagoas (TJAL)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Amapá (TJAP)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Amazonas (TJAM)
                                        </option>
                                        <option>
                                          Tribunal de Justiça da Bahia (TJBA)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Ceará (TJCE)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Distrito
                                          Federal e Territórios (TJDFT)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Espírito Santo
                                          (TJES)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Goiás (TJGO)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Maranhão (TJMA)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Mato Grosso
                                          (TJMT)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Mato Grosso do
                                          Sul (TJMS)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Minas Gerais
                                          (TJMG)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Pará (TJPA)
                                        </option>
                                        <option>
                                          Tribunal de Justiça da Paraíba (TJPB)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Paraná (TJPR)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Pernambuco
                                          (TJPE)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Piauí (TJPI)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Rio de Janeiro
                                          (TJRJ)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Rio Grande do
                                          Norte (TJRN)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Rio Grande do
                                          Sul (TJRS)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Rondônia (TJRO)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Roraima (TJRR)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Santa Catarina
                                          (TJSC)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de Sergipe (TJSE)
                                        </option>
                                        <option>
                                          Tribunal de Justiça de São Paulo
                                          (TJSP)
                                        </option>
                                        <option>
                                          Tribunal de Justiça do Tocantins
                                          (TJTO)
                                        </option>
                                        <option>
                                          Tribunal Regional Federal da 1ª Região
                                          (TRF1)
                                        </option>
                                        <option>
                                          Tribunal Regional Federal da 2ª Região
                                          (TRF2)
                                        </option>
                                        <option>
                                          Tribunal Regional Federal da 3ª Região
                                          (TRF3)
                                        </option>
                                        <option>
                                          Tribunal Regional Federal da 4ª Região
                                          (TRF4)
                                        </option>
                                        <option>
                                          Tribunal Regional Federal da 5ª Região
                                          (TRF5)
                                        </option>
                                        <option>
                                          Tribunal Regional Federal da 6ª Região
                                          (TRF6)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 1ª
                                          Região (TRT1)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 2ª
                                          Região (TRT2)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 3ª
                                          Região (TRT3)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 4ª
                                          Região (TRT4)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 5ª
                                          Região (TRT5)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 6ª
                                          Região (TRT6)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 7ª
                                          Região (TRT7)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 8ª
                                          Região (TRT8)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 9ª
                                          Região (TRT9)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 10ª
                                          Região (TRT10)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 11ª
                                          Região (TRT11)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 12ª
                                          Região (TRT12)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 13ª
                                          Região (TRT13)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 14ª
                                          Região (TRT14)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 15ª
                                          Região (TRT15)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 16ª
                                          Região (TRT16)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 17ª
                                          Região (TRT17)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 18ª
                                          Região (TRT18)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 19ª
                                          Região (TRT19)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 20ª
                                          Região (TRT20)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 21ª
                                          Região (TRT21)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 22ª
                                          Região (TRT22)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 23ª
                                          Região (TRT23)
                                        </option>
                                        <option>
                                          Tribunal Regional do Trabalho da 24ª
                                          Região (TRT24)
                                        </option>
                                        <option>CARF</option>
                                        <option>CADE</option>
                                        <option>PROCON</option>
                                      </Input>
                                      {validation.touched.leadTribunal &&
                                      validation.errors.leadTribunal ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadTribunal}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col lg={4}>
                                    <div className="mb-3">
                                      <Label className="form-label">Vara</Label>
                                      <Input
                                        name="leadVara"
                                        placeholder="Nome da Vara"
                                        type="text"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.leadVara || ""}
                                        invalid={
                                          validation.touched.leadVara &&
                                          validation.errors.leadVara
                                            ? true
                                            : false
                                        }
                                      />
                                      {validation.touched.leadVara &&
                                      validation.errors.leadVara ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadVara}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={3}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Data do Ajuizamento
                                      </Label>
                                      <Input
                                        name="leadDataAjuizamento"
                                        placeholder="dd/mm/aaaa"
                                        type="text"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values
                                            .leadDataAjuizamento || ""
                                        }
                                        invalid={
                                          validation.touched
                                            .leadDataAjuizamento &&
                                          validation.errors.leadDataAjuizamento
                                            ? true
                                            : false
                                        }
                                      />
                                      {validation.touched.leadDataAjuizamento &&
                                      validation.errors.leadDataAjuizamento ? (
                                        <FormFeedback type="invalid">
                                          {
                                            validation.errors
                                              .leadDataAjuizamento
                                          }
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col lg={3}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Valor da Causa
                                      </Label>
                                      <NumericFormat
                                        prefix="R$"
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        name="leadValorCausa"
                                        className="form-control"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadValorCausa || ""
                                        }
                                        // invalid={validation.touched.leadValorCausa && validation.errors.leadValorCausa ? true : false}
                                      />
                                      {/* {validation.touched.leadValorCausa && validation.errors.leadValorCausa ? (
                                                        <FormFeedback type="invalid">{validation.errors.leadValorCausa}</FormFeedback>
                                                    ) : null} */}
                                      {validation.touched.leadValorCausa &&
                                      validation.errors.leadValorCausa ? (
                                        <div style={{ color: "red" }}>
                                          {validation.errors.leadValorCausa}
                                        </div>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col lg={6}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Esfera
                                      </Label>
                                      <Input
                                        name="leadEsfera"
                                        type="select"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadEsfera || ""
                                        }
                                        invalid={
                                          validation.touched.leadEsfera &&
                                          validation.errors.leadEsfera
                                            ? true
                                            : false
                                        }
                                      >
                                        <option value="">Selecionar...</option>
                                        <option>Cível/Fiscal</option>
                                        <option>Trabalhista</option>
                                      </Input>
                                      {validation.touched.leadEsfera &&
                                      validation.errors.leadEsfera ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadEsfera}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={4}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Objeto Segurado
                                      </Label>
                                      <Input
                                        name="leadObjetoSegurado"
                                        type="select"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values
                                            .leadObjetoSegurado || ""
                                        }
                                        invalid={
                                          validation.touched
                                            .leadObjetoSegurado &&
                                          validation.errors.leadObjetoSegurado
                                            ? true
                                            : false
                                        }
                                      >
                                        <option value="">Selecionar...</option>
                                        <option>Recurso Ordinário</option>
                                        <option>Recurso de Revista</option>
                                        <option>
                                          Agravo de Instrumento Recurso
                                          Ordinário
                                        </option>
                                        <option>
                                          Agravo de Instrumento Recurso de
                                          Revista
                                        </option>
                                        <option>Garantia do Juízo</option>
                                      </Input>
                                      {validation.touched.leadObjetoSegurado &&
                                      validation.errors.leadObjetoSegurado ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadObjetoSegurado}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col lg={4}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Tipo do Lead
                                      </Label>
                                      <Input
                                        name="leadTipoLead"
                                        type="select"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadTipoLead || ""
                                        }
                                        invalid={
                                          validation.touched.leadTipoLead &&
                                          validation.errors.leadTipoLead
                                            ? true
                                            : false
                                        }
                                      >
                                        <option value="">Selecionar...</option>
                                        <option>Anulatória</option>
                                        <option>
                                          Anulatória - Tutela de Urgência
                                        </option>
                                        <option>
                                          Anulatória de Débito Fiscal
                                        </option>
                                        <option>
                                          Conhecimento - Antes da Sentença
                                        </option>
                                        <option>
                                          Conhecimento - Após a Sentença
                                        </option>
                                        <option>Declaratória</option>
                                        <option>Execução</option>
                                        <option>Execução Fiscal</option>
                                        <option>Execução Provisória</option>
                                        <option>Mandado de Segurança</option>
                                        <option>Processo Administrativo</option>
                                        <option>
                                          Tutela Antecipada Antecedente
                                        </option>
                                        <option>
                                          Tutela de Urgência Cautelar
                                        </option>
                                      </Input>
                                      {validation.touched.leadTipoLead &&
                                      validation.errors.leadTipoLead ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadTipoLead}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col lg={4}>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Situação do Lead
                                      </Label>
                                      <Input
                                        name="leadSituacaoLead"
                                        type="select"
                                        onChange={handleInputChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                          validation.values.leadSituacaoLead ||
                                          ""
                                        }
                                        invalid={
                                          validation.touched.leadSituacaoLead &&
                                          validation.errors.leadSituacaoLead
                                            ? true
                                            : false
                                        }
                                      >
                                        <option value="">Selecionar...</option>
                                        <option>
                                          Aguardando Despacho Citação
                                        </option>
                                        <option>Determinado Citação</option>
                                        <option>Expedido Citação</option>
                                        <option>Citado</option>
                                        <option>Pré-Executividade</option>
                                        <option>Discussão Cálculo</option>
                                        <option>Perito</option>
                                        <option>Homologa a Liquidação</option>
                                      </Input>
                                      {validation.touched.leadSituacaoLead &&
                                      validation.errors.leadSituacaoLead ? (
                                        <FormFeedback type="invalid">
                                          {validation.errors.leadSituacaoLead}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Collapse>
                          </div>
                        </div>
                      </Row>
                      <Row>
                        <div className="mt-3">
                          <h3 className="font-size-15 fw-bold">PUBLICAÇÕES</h3>
                          <Nav pills className="navtab-bg nav-tabs-publicacao">
                            {processo.Publicacoes.map(publi => [
                              <NavItem
                                style={{ textDecoration: "underline" }}
                                key={publi.Id}
                              >
                                <NavLink
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor: "#EEF1FD",
                                    border: "1px solid white",
                                  }}
                                  className={classnames({
                                    "mb-2": true,
                                  })}
                                  href={`#CardPublic-${publi.Id}`}
                                >
                                  {publi.DataPublicacao
                                    ? format(
                                        new Date(
                                          publi.DataPublicacao.substring(0, 10)
                                        ),
                                        "dd/MM/yyyy"
                                      )
                                    : "—"}
                                </NavLink>
                              </NavItem>,
                            ])}
                          </Nav>
                        </div>
                        <Row>
                          {processo.Publicacoes.map(publi => [
                            <Card key={publi.Id} id={`CardPublic-${publi.Id}`}>
                              <CardBody>
                                <Row>
                                  <div className="mt-3 p-2 bg-light border">
                                    <h5 className="font-size-14">
                                      {publi.PublicacaoTexto
                                        ? publi.PublicacaoTexto.Detalhamento
                                        : "[O DETALHAMENTO DESTA PUBLICAÇÃO NÃO ESTÝ DISPONÝVEL!]"}
                                    </h5>
                                  </div>
                                </Row>
                                <Row>
                                  <div className="d-flex flex-wrap gap-2 mt-3">
                                    <div className="mb-3 me-4">
                                      <label>Processo:</label>
                                      <div> {processo.NumeroCNJ}</div>
                                    </div>
                                    <div className="mb-3 me-4">
                                      <label>Empresa Mapeada:</label>
                                      <div> {publi.Cliente}</div>
                                    </div>
                                    <div className="mb-3 me-4">
                                      <label>Polo Passivo:</label>
                                      <div> {publi.PoloPassivo}</div>
                                    </div>
                                    <div className="mb-3 me-4">
                                      <label>Valor:</label>
                                      <div> R$ {publi.Valor}</div>
                                    </div>
                                    <div className="mb-3 me-4">
                                      <label>Empresa B3:</label>
                                      <div>{publi.EmpresaB3}</div>
                                    </div>
                                    <div className="mb-3 me-4">
                                      <label>Empresa Devedora:</label>
                                      <div>{publi.EmpresaDevedora}</div>
                                    </div>
                                    <div className="mb-3 me-4">
                                      <label>Empresa Ranking:</label>
                                      <div>{publi.EmpresaRanking}</div>
                                    </div>
                                  </div>
                                </Row>
                                <Row>
                                  <div className="mt-3">
                                    <h5 className="font-size-14">Tags</h5>
                                    <div className="font-size-14">
                                      {publi.Tags.map(tag => [
                                        <Badge
                                          key={tag.Id}
                                          color={tag.Estilo}
                                          className="me-1"
                                        >
                                          {tag.Titulo}
                                        </Badge>,
                                      ])}
                                    </div>
                                  </div>
                                </Row>
                                <Row>
                                  <div className="mt-3">
                                    <h5 className="font-size-14">Texto</h5>
                                    <p>
                                      {publi.PublicacaoTexto
                                        ? publi.PublicacaoTexto.Texto
                                        : "[O TEXTO DESTA PUBLICAÇÃO NÃO ESTÝ DISPONÝVEL!]"}
                                    </p>
                                  </div>
                                </Row>
                              </CardBody>
                            </Card>,
                          ])}
                        </Row>
                      </Row>
                      {/* *************************************************** */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Container>
      </div>

      <ApoliceModal
        processo={processo}
        show={modalApolice}
        onAddApolice={addNewApolice}
        onCloseClick={() => toggleApolice(false)}
        newIndex={apoliceList.length + 1}
      />

      <ConfirmModal
        message={customConfirmModal.Message}
        show={confirmModal}
        onConfirmClick={handleConfirmModal}
        onCloseClick={() => setConfirmModal(false)}
      />
    </React.Fragment>
  )
}

QualificacaoDetail.propTypes = {
  match: PropTypes.any,
}

export default withRouter(QualificacaoDetail)
